import DestinationPage from '@/components/DestinationPage';

const Soulac = () => {
  return (
    <DestinationPage
      title="Location de vélos à Soulac-sur-Mer"
      subtitle="Explorez Soulac et la Pointe du Médoc à vélo : plages océanes et forêts de pins"
      description="Soulac-sur-Mer, station balnéaire de la Pointe du Médoc, est une destination vélo authentique. Profitez des pistes cyclables qui longent l'océan, traversent les forêts de pins et relient les plages sauvages. Un terrain de jeu idéal pour les amateurs de nature et de grand air."
      highlights={[
        "Pistes cyclables le long de l'océan Atlantique",
        "Plages sauvages et spots de surf",
        "Forêt domaniale de pins maritimes",
        "Architecture Belle Époque",
        "Basilique Notre-Dame-de-la-Fin-des-Terres",
        "Itinéraires nature préservée"
      ]}
    />
  );
};

export default Soulac;